import React from 'react';
import dayjs from 'dayjs';
import { CnBox, CnButton } from '@cainiaofe/cn-ui';

import './index.scss';

const AiPositionList = (props) => {
  const { list, tip } = props;
  return (
    <div className="ai-position-list-wrap">
      <div
        className="ai-position-list-tip"
        style={
          list?.length > 0
            ? {
                marginBottom: 8
              }
            : {}
        }
      >
        {tip}
      </div>
      {list?.map((item) => (
        <div className="ai-position-list-item" key={item.id}>
          <CnBox direction="row" justify="space-between">
            <div className="list-item-title">{item.name}</div>
            <div
              className="list-item-btn"
              onClick={() =>
                window.open(`/campus/position-detail?positionId=${item.id}`)
              }
            >
              我要投递
            </div>
          </CnBox>
          <CnBox
            className="list-item-desc"
            direction="row"
            justify="space-between"
            spacing={12}
          >
            <div className="list-item-desc-time">
              更新于
              {item.modifyTime
                ? dayjs(item.modifyTime).format('YYYY-MM-DD')
                : '--'}
            </div>
            <div className="list-item-desc-category">
              {item.categoryName || '--'}
            </div>
            <div className="list-item-desc-workLocation">
              {item.workLocations ? item.workLocations.join('、') : '--'}
            </div>
          </CnBox>
        </div>
      ))}
    </div>
  );
};

export default AiPositionList;
